import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.querySelectorAll('img').forEach(this.#handleImage);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Hides broken or empty images in RTE content and marks loaded images
   * @param {HTMLImageElement} img
   */
  #handleImage(img) {
    const markLoaded = () => {
      if (img.naturalWidth > 0 && img.naturalHeight > 0) {
        img.classList.add('is-loaded');
        const parent = img.parentElement;
        if (parent && parent.tagName === 'P') {
          parent.style.removeProperty('display');
          parent.style.removeProperty('margin');
          parent.style.removeProperty('padding');
        }
      } else {
        markError();
      }
    };

    const markError = () => {
      img.classList.remove('is-loaded');
      img.style.setProperty('display', 'none', 'important');
      const parent = img.parentElement;
      if (parent && (parent.tagName === 'P' || (parent.tagName === 'A' && parent.parentElement && parent.parentElement.tagName === 'P'))) {
        const targetP = parent.tagName === 'P' ? parent : parent.parentElement;
        if (targetP.textContent.trim() === '') {
          targetP.style.setProperty('display', 'none', 'important');
          targetP.style.setProperty('margin', '0', 'important');
          targetP.style.setProperty('padding', '0', 'important');
          targetP.style.setProperty('height', '0', 'important');
        }
      }
    };

    const src = img.getAttribute('src');
    if (!src || src.trim() === '' || src === '#' || src.includes('{{') || src.includes('article.image') || src.includes('no-image') || src.includes('undefined') || src.includes('null')) {
      markError();
      return;
    }

    if (img.complete) {
      if (img.naturalWidth > 0) {
        markLoaded();
      } else {
        markError();
      }
    } else {
      img.addEventListener('load', markLoaded);
      img.addEventListener('error', markError);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
